import { createStateContext } from '@change-corgi/core/react/context';

import { mutations } from './mutations';
import type { VanityModalState } from './types';

export const {
	StateContext: VanityModalStateContext,
	StateProvider: VanityModalStateContextProvider,
	useStateContext: useVanityModalState,
} = createStateContext<VanityModalState, typeof mutations>({
	name: 'VanityModalStateContext',
	mutations,
	initialState: {
		viewState: 'CREATE',
		vanityUrl: '',
	},
});
